export var ValueNameType;
(function (ValueNameType) {
    ValueNameType["Alias"] = "aka";
    ValueNameType["Birth"] = "birth";
    ValueNameType["Immigration"] = "immigrant";
    ValueNameType["Maiden"] = "maiden";
    ValueNameType["Married"] = "married";
})(ValueNameType || (ValueNameType = {}));
//# sourceMappingURL=ValueNameType.js.map